import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export const SettingsDialog = ({ station, onClose, onSaved }) => {
  const [f, setF] = useState({ initial_liters: "", default_liters: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (station) setF({ initial_liters: station.initial_liters, default_liters: station.default_liters });
  }, [station]);
  if (!station) return null;
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/adblue/settings", { station_id: station.station_id, initial_liters: Number(f.initial_liters), default_liters: Number(f.default_liters) });
      toast.success("Magazzino aggiornato");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="adblue-settings-dialog">
        <DialogHeader>
          <DialogTitle>Magazzino AdBlue · {station.station_name}</DialogTitle>
          <DialogDescription>Il magazzino iniziale è la quantità di partenza; arrivi, rifornimenti e trasferimenti si sommano o si scalano da qui.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <div className="space-y-1.5"><Label>Magazzino iniziale (litri)</Label><Input type="number" min="0" step="0.1" value={f.initial_liters} onChange={(e) => setF({ ...f, initial_liters: e.target.value })} data-testid="adblue-initial-input" /></div>
          <div className="space-y-1.5"><Label>Litri di default per rifornimento furgone</Label><Input type="number" min="0" step="0.1" value={f.default_liters} onChange={(e) => setF({ ...f, default_liters: e.target.value })} data-testid="adblue-default-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={busy || f.initial_liters === "" || !(Number(f.default_liters) > 0)} data-testid="adblue-settings-save">{busy ? "Salvataggio..." : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
